import Input from '@liveauctioneers/caterwaul-components/lib/Input/Input';
import { FormattedMessage, injectIntl, IntlShape } from '@liveauctioneers/hammer-ui-core/intl';
import * as React from 'react';
import isEqual from 'react-fast-compare';

type Form = {
    fieldErrors: any;
    fieldValid: any;
};

type Props = {
    [x: string]: any;
    autoComplete?: string;
    form: Form;
    id: string;
    intl: IntlShape;
    label?: React.ReactNode;
} & React.ComponentProps<typeof Input>;

// This is intentionally a class component because the combination of memo and fast compare causes BUGS-1682
class FormInput extends React.Component<Props> {
    shouldComponentUpdate = (nextProps: Props) => !isEqual(this.props, nextProps);

    render() {
        const { autoComplete, form, id, intl, ...rest } = this.props;
        const { fieldErrors, fieldValid } = form;
        const { formatMessage } = intl;

        return (
            <Input
                {...rest}
                aria-label={formatMessage({ id: `formLabels.${id}` })}
                autoComplete={autoComplete}
                errorMessage={<FormattedMessage id={fieldErrors[id]} />}
                id={id}
                label={formatMessage({ id: `formLabels.${id}` })}
                valid={fieldValid[id]}
            />
        );
    }
}

export default injectIntl(FormInput);
